import { API_URL } from "constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (page, eventId) => page === 1 ? `${API_URL}/api/v1/crm/spot/search/${eventId}` : `${API_URL}/api/v1/crm/spot/search/${eventId}?page=${page}`;

const getAvailableSpots = async (page, eventId) => await apiRequest(getUrl(page, eventId), "get");

export default getAvailableSpots;